import React from 'react';

const FormButton = ({ children, ...rest }) => {
    return (
        <button type="submit" className="text-gray-100 w-full bg-[#41A6D7] hover:bg-[#3590BA] focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 focus:outline-none" {...rest}>
            {children}
        </button>
    );
};

export default FormButton;
